export function getHostname(): string {
  return globalThis.location.hostname;
}
